import { Link, Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Award, BarChart3, GitCompare, Layers, LineChart, MapPin, ShieldAlert, Users } from "lucide-react";
import { PGI_NAV_ITEMS } from "@/components/pgi/pgiConstants";
import SidebarUserCard from "@/components/SidebarUserCard";
import "../pages/PgiDashboard.css";
import "../styles/sqafSidebarShell.css";

const SIDEBAR_ICONS = {
  executive: BarChart3,
  ranking: MapPin,
  domains: Layers,
  yoy: LineChart,
  benchmark: GitCompare,
  risk: ShieldAlert,
  deepdive: MapPin,
  officials: Users,
};

const StandalonePgiLayout = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "executive";

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/login");
  };

  const goToTab = (tabId) => {
    const next = new URLSearchParams(searchParams);
    if (tabId === "executive") next.delete("tab");
    else next.set("tab", tabId);
    navigate({ pathname: "/pgi-dashboard", search: next.toString() ? `?${next.toString()}` : "" });
  };

  return (
    <div className="pgi-dashboard-root">
      <div className="app-shell">
        <aside className="sq-sidebar" aria-label="PGI dashboard sidebar">
          <div className="sq-sidebar-brand">
            <Link className="sq-sidebar-brand-main" to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <span className="sq-brand-icon" aria-hidden="true">
                <Award strokeWidth={2} width={22} height={22} />
              </span>
              <span className="sq-brand-copy">
                <strong>Pune District</strong>
                <span>PGI Dashboard 2024–25</span>
              </span>
            </Link>
          </div>

          <div className="sq-sidebar-scroll">
            <section className="sq-sidebar-section">
              <div className="sq-section-title">PGI Views</div>
              <nav className="sq-nav">
                {PGI_NAV_ITEMS.map(({ id, label }) => {
                  const Icon = SIDEBAR_ICONS[id] || Award;
                  return (
                    <button
                      key={id}
                      type="button"
                      className={`sq-nav-item${activeTab === id ? " active" : ""}`}
                      onClick={() => goToTab(id)}
                    >
                      <Icon strokeWidth={2} />
                      {label}
                    </button>
                  );
                })}
              </nav>
            </section>
          </div>

          <div className="sq-sidebar-footer">
            <SidebarUserCard user={user} onLogout={handleLogout} />
          </div>
        </aside>

        <main className="main">
          <header className="topbar">
            <div className="topbar-inner">
              <div className="breadcrumb">
                <Link to="/">Pune</Link>
                <span>›</span>
                <b>PGI District Dashboard</b>
              </div>
              <div className="top-actions">
                <Link to="/" className="icon-button" title="Back to landing" style={{ textDecoration: "none" }}>
                  <ArrowLeft strokeWidth={2} width={18} height={18} />
                </Link>
              </div>
            </div>
          </header>
          <Outlet context={{ user, activeTab }} />
        </main>
      </div>
    </div>
  );
};

export default StandalonePgiLayout;
